import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import styles from './index.module.sass'
import routes from '../../config/routes'

class Content extends Component {
  navHandler = index => {
    this.props.history.push(routes[index].path)
  }

  render() {
    const { pages = [] } = this.props
    const content =
      pages.find(({ path }) => path === window.location.pathname) || {}
    const { data = {} } = content

    const index = routes.findIndex(
      ({ path }) => this.props.location.pathname === path
    )
    const { data: staticData = {} } = routes[index]

    return (
      <div
        className={styles.content + ' ' + this.props.className}
        style={{
          transition: 'all 1s',
        }}>
        <div className={styles.content__text}>
          <h1>{data.title ? data.title : staticData.title}</h1>
          {data.description ? (
            <p
              className={styles.content__text__description}
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          ) : (
            <p
              className={styles.content__text__description}
              dangerouslySetInnerHTML={{ __html: staticData.description }}
            />
          )}
          <ul>
            {data.list
              ? (data.list || []).map(el => <li key={el}>• {el}</li>)
              : (staticData.list || []).map(el => <li key={el}>{el}</li>)}
          </ul>
        </div>
      </div>
    )
  }
}

export default withRouter(connect(state => state)(Content))
